import { formFieldModelEdit } from './ausenciaEmpleadoFormModel';

const {
  formField: {
    empleado_id,
    absence_type,
    start_date,
    end_date,
    description,
    certificate_url,
    approval_status,
  },
} = formFieldModelEdit;

export const formInitialValuesEdit = {
  [empleado_id.name]: null, // Autocomplete
  [absence_type.name]: null, // Select
  [start_date.name]: '',
  [end_date.name]: '',
  [description.name]: '',
  [certificate_url.name]: '',
  [approval_status.name]: null,
};
